@let fieldData = field();
@let formControl = control();

@if (formControl) {
  <div class="mb-6 relative">
    <tui-textfield
      tuiChevron
      class="workflow-field"
      tuiTextfieldSize="l"
      [tuiTextfieldCleaner]="true"
    >
      <label
        tuiLabel
        [class.font-extrabold!]="fieldData.isHighlighted"
        class="x-text-wf-title x-font-body-3-important"
      >
        {{ fieldData.title }}
      </label>
      <input tuiSelect [formControl]="formControl" />
      <tui-data-list-wrapper *tuiDropdown [items]="fieldData.options" />
      @if (fieldData.helpText) {
        <tui-icon [tuiTooltip]="fieldData.helpText" />
      }
    </tui-textfield>

    @if (formControl.invalid && (formControl.dirty || formControl.touched)) {
      <div class="x-text-wf-error x-font-body-5 mt-1 absolute">
        @if (formControl.hasError('required')) {
          <span>Обязательное поле</span>
        }
        @if (formControl.hasError('customError')) {
          <span>Ошибка валидации</span>
        }
      </div>
    }
  </div>
}
